import { render, staticRenderFns } from "./TestTinyMce.vue?vue&type=template&id=4acb7410&scoped=true"
import script from "./TestTinyMce.vue?vue&type=script&lang=js"
export * from "./TestTinyMce.vue?vue&type=script&lang=js"
import style0 from "./TestTinyMce.vue?vue&type=style&index=0&id=4acb7410&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4acb7410",
  null
  
)

export default component.exports